import * as React from "react";

import { cn } from "@/lib/utils";
import { Input } from "@/components/ui/input";

interface DateTimePickerProps {
  /** Value as datetime-local string (YYYY-MM-DDTHH:mm) */
  value?: string;
  /** Called with datetime-local string */
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  id?: string;
}

export const DateTimePicker = React.forwardRef<
  HTMLInputElement,
  DateTimePickerProps
>(({ value, onChange, disabled, className, id, ...props }, ref) => {
  return (
    <Input
      ref={ref}
      id={id}
      type="datetime-local"
      lang="de-CH"
      value={value ?? ""}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={disabled}
      className={cn("native-date-input", className)}
      {...props}
    />
  );
});
DateTimePicker.displayName = "DateTimePicker";
